import {
  DollarOutlined,
  CalendarOutlined,
  HourglassOutlined,
  VideoCameraOutlined,
  PhoneOutlined,
  NumberOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import {Space, Button} from "antd";
import {useState} from "react";
import {TBooking} from "../../../../redux/call/i-call";
import {capitalizeFirstLetter} from "../../../../services/helpers";
// import {CallCardMenu} from "../../upcoming-calls/call-card/call-card-menu";
import {
  StyledCallCard,
  StyledCallCardExtraInfo,
  StyledCardDetailsButtonWrapper,
} from "../../upcoming-calls/call-card/call-card.style";
import {CallDetailsModal} from "../../upcoming-calls/call-card/call-details-modal";
import {PastCallDetailsModal} from "../past-call-details-modal";

const PastCallCard = ({call}: {call: TBooking}) => {
  const [openViewDetailsModal, setOpenViewDetailsModal] = useState<boolean>(false);

  const showViewDetailsModal = () => {
    setOpenViewDetailsModal(true);
  };

  const handleOk = () => {
    setOpenViewDetailsModal(false);
  };

  const handleCancel = () => {
    setOpenViewDetailsModal(false);
  };

  const callDate = new Date(
    Number(call.booking_year),
    Number(call.booking_month) - 1,
    Number(call.booking_date)
  ).toDateString();

  const customerName = `${capitalizeFirstLetter(
    call?.first_name
  )} ${capitalizeFirstLetter(call?.last_name)}`;
  // The description comes from the service description (HTML), matching the
  // customer past-call card: strip the tags to render plain text.
  const callDescription = (call?.service?.description ?? "").replace(/<[^>]+>/g, "");
  return (
    <StyledCallCard
      title={`${customerName} - ${capitalizeFirstLetter(call?.service?.name)}`}
      //   extra={<CallCardMenu call={call} />}
    >
      <Space direction="vertical" size={18} style={{display: "flex"}}>
        <p className="call-card-description">{capitalizeFirstLetter(callDescription)}</p>
        <StyledCallCardExtraInfo>
          <div className="call-card-extra-info-item">
            <Space size={10}>
              <DollarOutlined style={{color: "#222222"}} />
              <span className="call-card-extra-info-item-value">
                {call.amount === 0
                  ? "Free"
                  : call.amount.toLocaleString("en-US") +
                    " " +
                    (call.currency || "Undefined")}
              </span>
            </Space>
          </div>
          <div className="call-card-extra-info-item">
            <Space size={10}>
              <CalendarOutlined style={{color: "#222222"}} />
              <span className="call-card-extra-info-item-value">{callDate}</span>
            </Space>
          </div>
          <div className="call-card-extra-info-item">
            <Space size={10}>
              <ClockCircleOutlined style={{color: "#222222"}} />
              <span className="call-card-extra-info-item-value">
                {call.coach_from_time || call.timeslot}
              </span>
            </Space>
          </div>
          <div className="call-card-extra-info-item">
            <Space size={10}>
              <HourglassOutlined style={{color: "#222222"}} />
              <span className="call-card-extra-info-item-value">
                {call?.service?.callDuration ?? "Undefined"} minutes
              </span>
            </Space>
          </div>
          <div className="phone-number-extra-details">
            <div className="call-card-extra-info-item">
              <Space size={10}>
                {call.booking_type === "video" ? (
                  <>
                    <VideoCameraOutlined style={{color: "#222222"}} />
                    <span className="call-card-extra-info-item-value">Video call</span>
                  </>
                ) : (
                  <>
                    <PhoneOutlined style={{color: "#222222"}} />
                    <span className="call-card-extra-info-item-value">Phone call</span>
                  </>
                )}
              </Space>
            </div>
            {call.booking_type === "audio" && (
              <div className="call-card-extra-info-item">
                <Space size={10}>
                  <NumberOutlined style={{color: "#222222"}} />
                  <span className="call-card-extra-info-item-value">
                    {call.phone_number}
                  </span>
                </Space>
              </div>
            )}
          </div>
        </StyledCallCardExtraInfo>

        <StyledCardDetailsButtonWrapper>
          <div>
            {/* <StyledServiceButtonWrapper> */}
            <Button size="small" block type="default" onClick={showViewDetailsModal}>
              View details
            </Button>
          </div>

          {/* </StyledServiceButtonWrapper> */}
        </StyledCardDetailsButtonWrapper>
      </Space>

      <CallDetailsModal
        visibleState={openViewDetailsModal}
        title={`${capitalizeFirstLetter(
          call?.service?.name ?? "Undefined"
        )} with ${capitalizeFirstLetter(call.first_name)} ${capitalizeFirstLetter(
          call.last_name
        )}`}
        okFunc={handleOk}
        cancelFunc={handleCancel}
        footerContent={[
          <Button size="small" onClick={handleOk} key="okay" type="primary">
            Ok
          </Button>,
        ]}
      >
        <PastCallDetailsModal call={call} />
      </CallDetailsModal>
    </StyledCallCard>
  );
};

export {PastCallCard};
